export { InventarioInicialTab } from "./InventarioInicialTab";
